import { useEffect } from 'react';
import './hybrid.css';
import bodyHtml from './hybrid-body.html?raw';
import { initHybrid } from './hybrid-init';

export default function HomePage() {
  useEffect(() => {
    document.title = '每日為孩子禱告｜13 年每日為孩子守望禱告';
    document.documentElement.lang = 'zh-Hant';
    return initHybrid();
  }, []);
  return <div className="hybrid-root" dangerouslySetInnerHTML={{ __html: bodyHtml }} />;
}
